import i18n from "i18n";
import { isHealthFeature } from "./HealthReport.types";
const SEVERITY_RANK = { critical: 3, warning: 2, unknown: 1, healthy: 0 };
export const findMostSevereLeafId = (root) => {
  let best;
  const visit = (node) => {
    if (isHealthFeature(node) && node.children.length > 0) {
      node.children.forEach(visit);
      return;
    }
    const rank = SEVERITY_RANK[node.status];
    if (rank > 0 && (best === void 0 || rank > best.rank)) {
      best = { id: node.id, rank };
    }
  };
  visit(root);
  return best == null ? void 0 : best.id;
};
export const formatLeafCount = (node) => {
  if (!node.total_affected) return void 0;
  if (typeof node.total === "number") return `${node.total_affected}/${node.total}`;
  return `${node.total_affected}`;
};
export const formatLeafCountVerbose = (node, noun) => {
  if (!node.total_affected) return void 0;
  const options = { ns: "enterprise_license", affected: node.total_affected, total: node.total, noun };
  if (typeof node.total === "number") {
    return noun ? i18n.t("health.leaf_count_of_total_noun_affected", options) : i18n.t("health.leaf_count_of_total_affected", options);
  }
  return noun ? i18n.t("health.leaf_count_noun_affected", options) : i18n.t("health.leaf_count_affected", options);
};
export const countContainedChecks = (node) => {
  if (!isHealthFeature(node)) return 1;
  return node.children.reduce((count, child) => count + countContainedChecks(child), 0);
};
export const countLeavesByStatus = (nodes) => {
  const counts = { healthy: 0, warning: 0, critical: 0, unknown: 0 };
  const visit = (node) => {
    if (isHealthFeature(node) && node.children.length > 0) {
      node.children.forEach(visit);
      return;
    }
    counts[node.status] += 1;
  };
  nodes.forEach(visit);
  return counts;
};
export const PROBLEM_STATUSES = ["critical", "warning", "unknown"];
export const countProblems = (counts) => PROBLEM_STATUSES.reduce((total, status) => total + counts[status], 0);
export const hasProblem = (node) => node.status !== "healthy" || isHealthFeature(node) && node.children.some(hasProblem);
export const collectUnhealthyExpansionIds = (node) => {
  if (!isHealthFeature(node) || !hasProblem(node)) return [];
  return [node.id, ...node.children.flatMap(collectUnhealthyExpansionIds)];
};
export const collectDescendantFeatureIds = (node) => {
  if (!isHealthFeature(node)) return [];
  return node.children.flatMap(
    (child) => isHealthFeature(child) ? [child.id, ...collectDescendantFeatureIds(child)] : []
  );
};
const pruneHealthy = (nodes) => nodes.flatMap((node) => {
  if (!hasProblem(node)) return [];
  if (!isHealthFeature(node)) return [node];
  return [{ ...node, children: pruneHealthy(node.children) }];
});
export const filterProblems = (report) => ({
  ...report,
  features: pruneHealthy(report.features)
});
export const collectBranchFeatureIds = (node) => isHealthFeature(node) ? node.children.filter((child) => isHealthFeature(child) && child.children.some(isHealthFeature)).map((child) => child.id) : [];
export const collectAncestorFeatureIds = (root, targetId) => {
  var _a;
  const find = (node) => {
    if (node.id === targetId) return [];
    if (!isHealthFeature(node)) return null;
    const childPath = node.children.map(find).find((path) => path !== null);
    return childPath ? [node.id, ...childPath] : null;
  };
  return (_a = find(root)) != null ? _a : [];
};
